/**
 * Created by vladislav on 1/26/2024
 */

const MSStartLogic = function () {
    PlatformLogic.call(this);

    connector.ads.on("error:details:msstart:cache", this.onAdCacheError.bind(this));
    connector.ads.on("error:details:msstart:play", this.onAdPlayError.bind(this));
};

MSStartLogic.prototype = Object.create(PlatformLogic.prototype);
MSStartLogic.prototype.constructor = MSStartLogic;

MSStartLogic.prototype.onAdCacheError = function (errorCode, originalError) {
    if (this.isAdBlock(originalError)) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.MSSTART.ADS_ADBLOCK);
        return;
    }

    switch (errorCode) {
        case "FAILURE0": // VAST Parser didn't answer until timeout
        case "FAILURE100": // Vast Parser error (100)
        case "FAILURE101": // andrey ru error message - Vast Parser error (101)
        case "FAILURE303": // Vast Parser error (303)
        case "FAILURE403": // Unable to select rendition
        case "FAILURE900": // General error reported from HTML5 video player
        case "FAILURE903": // Heavy Ad Intervention by browser detected.
        case "FAILURE10000": // No ad loader found.
        case "API_ACCESS_DENIED": // Access denied to this API.
        case "NO_AD_LOADER_FOUND":
        case "AD_ALREADY_LOADED":
        case "AD_IS_BEING_LOADED":
        case "AD_REQUIRES_ACTIVE_TAB":
        case "REQUEST_THROTTLED":
        case "SHOWING_ADS_THROTTLED": // ShowAdsAsync cooldown during game init
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.MSSTART.ADS_LOAD + errorCode);
            break;
        default:
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.STATS.MSSTART.ADS_LOAD}OTHER`);
            cleverapps.throwAsync(`${cleverapps.EVENTS.STATS.MSSTART.ADS_LOAD + originalError.code} message: ${JSON.stringify(originalError)}`);
    }
};

MSStartLogic.prototype.isAdBlock = function (originalError) {
    return Boolean(originalError && originalError.extra && originalError.extra.adBlockerDetected);
};

MSStartLogic.prototype.onAdPlayError = function (errorCode, originalError) {
    if (this.isAdBlock(originalError)) {
        cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.MSSTART.ADS_ADBLOCK);
        return;
    }

    switch (errorCode) {
        case "COMPLETED_FAILURE0": // Exception error: TypeError
        case "COMPLETED_FAILURE402": // VPAID AdError reported from JS VPAID player
        case "COMPLETED_FAILURE900": // General error reported from HTML5 video player
        case "COMPLETED_FAILURE901": // VPAID AdError reported from JS VPAID player | VAST AdError reported from JS VPAID player
        case "COMPLETED_FAILURE903": // Heavy Ad Intervention by browser detected.  Browser Message: Ad was removed because its network usage exceeded the limit.
        case "FAILURE0": // VAST Parser didn't answer until timeout
        case "FAILURE301": // Vast Parser error (301)
        case "FAILURE303": // Vast Parser error (303)
        case "FAILURE403": // Unable to select rendition
        case "FAILURE903": // Heavy Ad Intervention by browser detected.
        case "NO_LOADED_ADS_WITH_ID":
        case "AD_ID_NOT_FOUND": // MSN now reports "no loaded ads" via extra.subCode
        case "REQUEST_THROTTLED":
        case "SHOWING_ADS_THROTTLED": // ShowAdsAsync cooldown during game init
        case "FAILED_BY_TIMEOUT":
        case "AD_REQUIRES_ACTIVE_TAB":
        case "USER_CANCELED":
        case "FAILURE":
        case "COMPLETED_FAILURE":
        case "EMPTY_VAST":
        case "NO_AD_NODE":
        case "FAILURE100": // synthesized fallback for EMPTY_VAST
        case "FAILURE101": // synthesized fallback for NO_AD_NODE
            cleverapps.metrics.logEvent(cleverapps.EVENTS.STATS.MSSTART.ADS_PLAY + errorCode);
            break;
        default:
            cleverapps.metrics.logEvent(`${cleverapps.EVENTS.STATS.MSSTART.ADS_PLAY}OTHER`);
            cleverapps.throwAsync(`${cleverapps.EVENTS.STATS.MSSTART.ADS_PLAY + originalError.code} message: ${JSON.stringify(originalError)}`);
    }
};

MSStartLogic.prototype.logPushes = function () {
    const params = cleverapps.getRequestParameters();
    const pushCode = params && params.notificationPayload && JSON.parse(params.notificationPayload).push_code;

    if (pushCode) {
        this.logClickEvent(pushCode);
    }
};

MSStartLogic.prototype.reportScore = function (score, callback) {
    if (!connector.social.isLoggedIn()) {
        callback(cleverapps.CODE_FAILED);
        return;
    }

    $msstart.submitGameResultsAsync(score).then((result) => {
        callback(result ? cleverapps.CODE_SUCCEED : cleverapps.CODE_FAILED);
    }).catch(() => {
        callback(cleverapps.CODE_FAILED);
    });
};